import { render, staticRenderFns } from "./promoter-mapping-modal.vue?vue&type=template&id=252e9a76&scoped=true"
import script from "./promoter-mapping-modal.vue?vue&type=script&lang=js"
export * from "./promoter-mapping-modal.vue?vue&type=script&lang=js"
import style0 from "./promoter-mapping-modal.vue?vue&type=style&index=0&id=252e9a76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252e9a76",
  null
  
)

export default component.exports